export namespace Global {
	let calculateScrollBarPostion = () => {
		// Create a div element with a specified style
		var el = document.createElement('div');
		el.style.width = '100%';

		// Append the element to the body
		document.body.appendChild(el);

		// Get the width of the element with the specified style
		var constrainedWidth = el.offsetWidth;

		// Update the style to 100vw
		el.style.width = '100vw';

		// Get the width of the element after the style update
		var fullWidth = el.offsetWidth;

		// Calculate the scrollbar width
		var scrollbarWidth = Math.ceil(fullWidth - constrainedWidth);

		// Set a CSS variable with the calculated scrollbar width
		document.documentElement.style.setProperty('--scrollbar-width', scrollbarWidth + 'px');

		// Remove the temporary element from the body
		document.body.removeChild(el);
	};

	let setTouchOrNoTouch = () => {
		let isTouchDevice = () => {
			return window.matchMedia('(pointer: coarse)').matches;
		};

		if (isTouchDevice()) {
			document.body.classList.add('touch');
			document.body.classList.remove('no-touch');
		} else {
			document.body.classList.remove('touch');
			document.body.classList.add('no-touch');
		}
	};

	const checkExternalLinks = () => {
        function isExternal(url: string): boolean {
            try {
                const target = new URL(url, window.location.href);
                return target.origin !== window.location.origin;
            } catch {
                return false;
            }
        }

        document.querySelectorAll<HTMLAnchorElement>('a').forEach(anchor => {
            if (isExternal(anchor.href)) {
                anchor.target = '_blank';
                anchor.rel = 'noopener noreferrer';
            }
        });
    };

	export const init = () => {
		console.log('Hello from Global.init');
		calculateScrollBarPostion();
		setTouchOrNoTouch();
		checkExternalLinks();
	};
}

Global.init();
